import * as React from 'react'
import Divider from '@mui/material/Divider'
import Container from '@mui/material/Container'
import Layout from 'src/components/organisms/Layout'
import Hero from 'src/components/organisms/HomeHero'
import ElevatedCard from 'src/components/molecules/ElevatedCard'
import ContentAndIconsSection from 'src/components/organisms/ContentAndIconsSection'
import LogoGridSection from 'src/components/organisms/LogoGridSection'
import SEO from 'src/utils/seo'
import {bk} from 'src/assets/images'
import {analytics} from 'src/assets/images/backgrounds'
import type {ReactJSXElement} from '@emotion/react/types/jsx-namespace'

type Icon = {
  icon: ReactJSXElement
  title: string
}

interface Logo {
  url: string
  alt: string
}

interface LogoList {
  logo: Logo
  title: {
    text: string
  }
  aria_label: {
    text: string
  }
}

interface Props {
  icons: {
    data: Icon[]
    analytics: Icon[]
    solutions: Icon[]
  }
  logos: LogoList[]
  heroContent: () => ReactJSXElement
  elevatedCardContent: () => ReactJSXElement
  dataContent: () => ReactJSXElement
  analyticsContent: () => ReactJSXElement
  solutionsContent: () => ReactJSXElement
  logoSectionContent: () => ReactJSXElement
}

const HomePage = ({
  icons,
  heroContent: HeroContent,
  elevatedCardContent: ElevatedCardContent,
  dataContent,
  analyticsContent,
  solutionsContent,
  logos,
  logoSectionContent,
}: Props) => {
  return (
    <Layout>
      <SEO title="NCFX | FX Benchmark Analytics" />
      <Hero background={bk} fullHeight>
        <HeroContent />
      </Hero>
      <ElevatedCard overlapTop centered>
        <ElevatedCardContent />
      </ElevatedCard>
      <ContentAndIconsSection icons={icons.data} content={dataContent} />
      <ContentAndIconsSection
        variant="contentRight"
        icons={icons.analytics}
        bk={analytics}
        content={analyticsContent}
      />
      <ContentAndIconsSection
        icons={icons.solutions}
        content={solutionsContent}
      />
      <Container maxWidth="lg">
        <Divider />
      </Container>
      <LogoGridSection logos={logos} content={logoSectionContent} />
      <Container maxWidth="lg">
        <Divider />
      </Container>
    </Layout>
  )
}

export default HomePage
